// Promise is required for correct lazy loading of other polyfills
// so we need to always include it before other polyfills
import 'polyfills/promise/polyfill';

import { REACT_APP_API_URL } from 'helpers/conf';
import { getBootLocalePromise } from 'modules/locale/boot';
import polyfills from 'polyfills';

async function showReactDOM() {
  try {
    await Promise.all(polyfills);
  } catch (error) {
    console.error('Error loading polyfills:', error);
  }

  console.log('******** APP TS', REACT_APP_API_URL);
  // Starts locale detection without blocking the app.
  getBootLocalePromise();
  require('renderer');
}

showReactDOM();
